import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Response} from '@angular/http';

import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';

import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';
import {Candidature} from './candidature.model';
import {CandidatureFormationService} from './candidature-formation.service';
import {CandidatureFormation} from './candidature-formation.model';
import {CandidaturePopupService} from './candidature-popup.service';
import {CONSTANTS} from '../../cadens.constants';
import {Formation, FormationService} from '../formation';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'jhi-candidature-traitement-dialog',
    templateUrl: './candidature-traitement-dialog.component.html'
})
export class CandidatureTraitementDialogComponent implements OnInit {

    candidatureFormation: CandidatureFormation;
    authorities: any[];
    isSaving: boolean;
    fr: any;
    Constants = CONSTANTS;
    listeConformites = [CONSTANTS.CONFORME, CONSTANTS.NOTCONFORME];
    listeResultats = [CONSTANTS.SUCCESS, CONSTANTS.REJECTED];
    affichageRang = false;
    private rangAuto = false ;

    constructor(public activeModal: NgbActiveModal,
                private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                private router: Router,
                private candidatureFormationService: CandidatureFormationService,
                private eventManager: EventManager,
                private formationService: FormationService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService) {
        this.jhiLanguageService.setLocations(['candidature']);
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.formationService.findPourEtudiant(this.candidatureFormation.formationId, this.candidatureFormation.userId).subscribe(
            (res: Formation) => {
                if (res.lc === true) {
                    this.listeResultats.push(CONSTANTS.AWAITING);
                }
                if (res.rang === true) {
                    this.affichageRang = true;
                    this.rangAuto = res.rangAuto;
                }
            });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.candidature.confirmSave.message'),
            header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
            icon: 'fa fa-check-circle-o',
            key: 'traiter',
            accept: () => {
                this.isSaving = true;
                this.candidatureFormationService.updateCandidaturesStatus([this.candidatureFormation],
                    {
                        response: this.candidatureFormation.response,
                        conforme: this.candidatureFormation.conforme
                    }).subscribe(res => {
                    this.onSaveSuccess(res);
                }, (res: Response) => this.onSaveError(res.json()));
            }
        });
    }

    selectReponse(response) {
        this.candidatureFormation.response = (this.candidatureFormation.response === response) ? null : response;
        if (this.candidatureFormation.response !== CONSTANTS.AWAITING) {
            this.candidatureFormation.responseRang = null;
        }
    }

    selectConformite(conformite) {
        this.candidatureFormation.conforme = (this.candidatureFormation.conforme === conformite) ? null : conformite;
    }

    private onSaveSuccess(result: Candidature) {
        this.eventManager.broadcast({name: 'candidatureListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
        this.router.navigate(['/candidature/' + result.id]);
    }

    private onSaveError(error) {
        this.eventManager.broadcast({name: 'candidatureListModification', content: 'NOK'});
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-candidature-traitement-popup',
    template: ''
})
export class CandidatureTraitementPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(private route: ActivatedRoute,
                private candidaturePopupService: CandidaturePopupService) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.candidaturePopupService
                    .open(CandidatureTraitementDialogComponent, params['id']);
            } else {
                this.modalRef = this.candidaturePopupService
                    .open(CandidatureTraitementDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-traitement-dialog.component.ts